module.exports = __webpack_public_path__ + "img/img-thinking.03972ed0.svg";